import { render, staticRenderFns } from "./OrderSubtotal.vue?vue&type=template&id=0226c9ca&"
import script from "./OrderSubtotal.vue?vue&type=script&lang=js&"
export * from "./OrderSubtotal.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubtotal.vue?vue&type=style&index=0&id=0226c9ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports